<div class='buyer-create-v2-shell'>
  <div class='buyer-create-v2-hidden'>
    <ngx-buyer-create
      [cities]='cities'
      [taskTypes]='taskTypes'
      [taskStatuses]='taskStatuses'
      (navigateBuyerEvent)='navigateBuyerEvent.emit($event)'
      (editDone)='editDone.emit($event)'
      (newDone)='newDone.emit($event)'
      (reserveBuyer)='reserveBuyer.emit($event)'
      (ownSet)='ownSet.emit($event)'>
    </ngx-buyer-create>
  </div>

  <form *ngIf='buyerCreate?.buyerForm as buyerForm' [formGroup]='buyerForm'>
    <nb-card class='border-0 background-color-v2 prospect-dialog-card buyer-create-v2-card'>
      <nb-card-header class='header-card'>
        <div class='buyer-header'>
          <div class='buyer-header-row'>
            <button
              type='button'
              nbButton size='large'
              class='large max-right mobile-view buyer-back-button'
              (click)='back()'>
              <nb-icon icon='arrow-back-outline' pack='eva'></nb-icon>
            </button>

            <div class='name-line'>
              <ng-container *ngIf='!isBlank'>
                <span class='buyer-name-text'>{{ buyerForm.controls?.name?.value || 'New' }} {{ buyerForm.controls?.surname?.value || 'Buyer' }}</span>
                <span *ngIf='compactBuyerCode() as compactCode' class='compact-buyer-code'>
                  ({{ compactCode }}<span
                    *ngIf='buyerCreate?.data?.matchedProspectCount !== null
                      && buyerCreate?.data?.matchedProspectCount !== undefined'
                    class='matched-prospect-count'>.{{ buyerCreate.data.matchedProspectCount || 0 }}</span>)
                </span>
              </ng-container>
            </div>

            <div class='buyer-header-actions'>
              <div class='buyer-mode-toggle'>
              <button type='button' nbButton size='tiny' class='buyer-mode-button'
                      [ngClass]="{'buyer-mode-button-active': buyerForm.controls?.isWot?.value}"
                      [status]='buyerForm.controls?.isWot?.value ? "info" : "basic"'
                      (click)='toggleWot()'>WOT</button>
              <button type='button' nbButton size='tiny' class='buyer-mode-button'
                      [ngClass]="{'buyer-mode-button-active': buyerForm.controls?.buyerCode?.value === 'B' || buyerForm.controls?.buyerCode?.value === 'VB'}"
                      [status]='buyerForm.controls?.buyerCode?.value === "B" || buyerForm.controls?.buyerCode?.value === "VB" ? "info" : "basic"'
                      (click)='setBuyerMode("buyer")'>B</button>
              <button type='button' nbButton size='tiny' class='buyer-mode-button'
                      [ngClass]="{'buyer-mode-button-active': buyerForm.controls?.buyerCode?.value === 'T'}"
                      [status]='buyerForm.controls?.buyerCode?.value === "T" ? "info" : "basic"'
                      (click)='setBuyerMode("tenant")'>T</button>
            </div>
          </div>
          </div>
          <div class='buyer-header-address'>
            <div>{{ overviewAddress() }}</div>
          </div>
        </div>
      </nb-card-header>

      <nb-card-body class='padding-override'>
        <div class='row m-0'>
          <div class='col-4 m-0'></div>
          <div class='col-4 m-0'></div>
          <div class='col-4 m-0 d-flex'></div>
        </div>

        <div class='row m-0 mt-2'>
          <div class='col-12 d-flex justify-content-center p-1'>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details'
                      (click)='buyerCreate.setSquareValue("mail")'>
                <span [ngClass]='buyerForm.controls.mail.value ? "line-through" : ""'>Mail</span>
              </button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details'
                      (click)='buyerCreate.setSquareValue("call")'>
                <span [ngClass]='buyerForm.controls.call.value ? "line-through" : ""'>Call</span>
              </button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details'
                      (click)='buyerCreate.setSquareValue("sms")'>
                <span [ngClass]='buyerForm.controls.sms.value ? "line-through" : ""'>Sms</span>
              </button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='button-details buyer-active-toggle'
                      [ngClass]="{'buyer-active-toggle-inactive': activeStatusLabel() === 'INACTIVE'}"
                      (click)='toggleActiveStatus()'>{{ activeStatusLabel() }}</button>
            </div>
          </div>

          <div class='col-12 d-flex justify-content-center p-1 mt-2'>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='custom-client-detail-back-button'
                      (click)='navigateBuyer(false)'>BACK</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='button-details'
                      (click)='noAnswerAndNext()'>NA</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='button-details'
                      (click)='createTask()'>APP</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='custom-client-detail-next-button'
                      (click)='navigateBuyer(true)'>NEXT</button>
            </div>
          </div>

          <div class='col-12 d-flex justify-content-center p-1 mt-2'>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details border'
                      [status]='!isBlank && buyerForm.controls.isValueBuyer.value ? "info" : "basic"'
                      (click)='buyerCreate.setBuyerType("isValueBuyer")'>VB</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details border'
                      [status]='!isBlank && buyerForm.controls.isInvestor.value ? "info" : "basic"'
                      (click)='buyerCreate.setBuyerType("isInvestor")'>I</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details border'
                      [status]='!isBlank && buyerForm.controls.isFirstHome.value ? "info" : "basic"'
                      (click)='buyerCreate.setBuyerType("isFirstHome")'>F</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small' class='button-details border'
                      [status]='!isBlank && buyerForm.controls.isDeveloper.value ? "info" : "basic"'
                      (click)='buyerCreate.setBuyerType("isDeveloper")'>D</button>
            </div>
          </div>

          <div class='col-12 d-flex justify-content-center p-1 mt-2 buyer-section-switcher'>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'C'}"
                      [status]='!isBlank && isSectionView && activeSection === "C" ? "primary" : "basic"'
                      (click)='setActiveSection("C")'>C</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'A'}"
                      [status]='!isBlank && isSectionView && activeSection === "A" ? "primary" : "basic"'
                      (click)='setActiveSection("A")'>A</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'N'}"
                      [status]='!isBlank && isSectionView && activeSection === "N" ? "primary" : "basic"'
                      (click)='setActiveSection("N")'>N</button>
            </div>
            <div class='col-3 text-center'>
              <button type='button' nbButton fullWidth size='small'
                      class='border section-toggle-button buyer-letter-toggle'
                      [ngClass]="{'section-toggle-button-active': !isBlank && isSectionView && activeSection === 'I'}"
                      [status]='!isBlank && isSectionView && activeSection === "I" ? "primary" : "basic"'
                      (click)='setActiveSection("I")'>I</button>
            </div>
          </div>

          <ng-container *ngIf='!isSectionView || isCreateMode'>
          <div class='col-12 mt-2'>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-6'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth name='name'
                           formControlName='name' placeholder='Name'
                           [ngClass]='buyerCreate.showError("name")'>
                  </div>
                  <div class='col-6'>
                    <input type='text' nbInput fieldSize='tiny' fullWidth name='surname'
                           formControlName='surname' placeholder='Surname'
                           [ngClass]='buyerCreate.showError("surname")'>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Phone Number</div>
                  <div class='col-12 mt-1 buyer-phone-row'>
                    <input type='tel' nbInput fieldSize='tiny' fullWidth class='no-border-input buyer-phone-input'
                           formControlName='mobilePhone' placeholder='Phone Number'>
                    <a class='buyer-phone-call'
                       *ngIf='buyerForm.controls?.mobilePhone?.value'
                       [href]='"tel:" + buyerForm.controls.mobilePhone.value'
                       (click)='buyerCreate.lastCalledPhoneNumber = buyerForm.controls.mobilePhone.value'
                       aria-label='Call phone number'>
                      <nb-icon icon='phone-call-outline' pack='eva'></nb-icon>
                    </a>
                    <a class='buyer-phone-message'
                       *ngIf='buyerForm.controls?.mobilePhone?.value'
                       [href]='"sms:" + buyerForm.controls.mobilePhone.value'
                       aria-label='Message phone number'>
                      <nb-icon icon='message-circle-outline' pack='eva'></nb-icon>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>Email</div>
                  <div class='col-12 mt-1'>
                    <input nbInput fieldSize='tiny' fullWidth class='no-border-input buyer-email-input'
                           formControlName='email' placeholder='Email'>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class='col-12 buyer-main-view'>
            <div class='row m-1 custom-area mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-10 mt-1 buyer-row-value buyer-property-summary'>
                    <ng-container *ngIf='!isBlank && sectionSummary("C"); else commonDetails'>
                      <span class='buyer-property-specs'>
                        <span *ngIf='buyerForm.controls?.type?.value'>
                          {{ propertyTypeInitial() }}
                        </span>
                        <span *ngIf='buyerForm.controls?.bed?.value'>
                          <i class='fa fa-bed mr-1'></i>{{ buyerForm.controls.bed.value }}
                        </span>
                        <span *ngIf='buyerForm.controls?.bath?.value'>
                          <i class='fa fa-bath mr-1'></i>{{ buyerForm.controls.bath.value }}
                        </span>
                        <span *ngIf='buyerForm.controls?.car?.value'>
                          <i class='fa fa-car mr-1'></i>{{ buyerForm.controls.car.value }}
                        </span>
                        <span *ngIf='buyerForm.controls?.land?.value'>
                          {{ buyerForm.controls.land.value }} m<sup>2</sup>
                        </span>
                      </span>
                      <span class='buyer-property-price'>
                        <span *ngIf='buyerForm.controls?.minBuyPrice?.value'>
                          <ng-container *ngIf='buyerForm.controls?.tenant?.value || buyerForm.controls?.buyerCode?.value === "T"; else minBuyBudget'>
                            ${{ buyerForm.controls.minBuyPrice.value }}/w
                          </ng-container>
                          <ng-template #minBuyBudget>{{ buyerForm.controls.minBuyPrice.value / 1000 | number:'1.0-0' }}k</ng-template>
                        </span>
                        <span *ngIf='buyerForm.controls?.maxBuyPrice?.value && buyerForm.controls?.maxBuyPrice?.value !== buyerForm.controls?.minBuyPrice?.value'>
                          <ng-container *ngIf='buyerForm.controls?.tenant?.value || buyerForm.controls?.buyerCode?.value === "T"; else maxBuyBudget'>
                            ${{ buyerForm.controls.maxBuyPrice.value }}/w
                          </ng-container>
                          <ng-template #maxBuyBudget>{{ buyerForm.controls.maxBuyPrice.value / 1000 | number:'1.0-0' }}k</ng-template>
                        </span>
                      </span>
                    </ng-container>
                    <ng-template #commonDetails>{{ isBlank ? '' : 'Common details' }}</ng-template>
                  </div>
                  <div class='col-2 buyer-row-key'>
                    <button type='button' class='buyer-row-key-button'
                            [ngClass]="{'buyer-row-key-button-active': !isBlank && buyerForm.controls?.isCommon?.value}"
                            (click)='buyerCreate.setBuyerAttribute("isCommon")'>
                      C
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row m-1 custom-area mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-10 mt-1 buyer-row-value'>{{ isBlank ? '' : (sectionSummary('A') || 'Address details') }}</div>
                  <div class='col-2 buyer-row-key'>
                    <button type='button' class='buyer-row-key-button'
                            [ngClass]="{'buyer-row-key-button-active': !isBlank && buyerForm.controls?.isAddress?.value}"
                            (click)='buyerCreate.setBuyerAttribute("isAddress")'>
                      A
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row m-1 custom-area mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-10 mt-1 buyer-row-value'>{{ isBlank ? '' : (sectionSummary('N') || 'Number details') }}</div>
                  <div class='col-2 buyer-row-key'>
                    <button type='button' class='buyer-row-key-button'
                            [ngClass]="{'buyer-row-key-button-active': !isBlank && buyerForm.controls?.isNumber?.value}"
                            (click)='buyerCreate.setBuyerAttribute("isNumber")'>
                      N
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row m-1 custom-area mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-10 mt-1 buyer-row-value'>{{ isBlank ? '' : (sectionSummary('I') || 'Inspection details') }}</div>
                  <div class='col-2 buyer-row-key'>
                    <button type='button' class='buyer-row-key-button'
                            [ngClass]="{'buyer-row-key-button-active': !isBlank && buyerForm.controls?.isInspection?.value}"
                            (click)='buyerCreate.setBuyerAttribute("isInspection")'>
                      I
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class='row m-1 custom-area mt-2'>
              <div class='col-12'>
                <div class='row m-0 p-2'>
                  <div class='col-12'>
                    <textarea nbInput fieldSize='tiny' fullWidth rows='4'
                              formControlName='note'
                              placeholder='Note'
                              class='no-border-input buyer-note-input'></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </ng-container>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "C")'>
            <div class='row custom-area m-1 mt-2 p-2 property-price-container'>
              <div class='col-2'>
                <select formControlName='type' (change)='buyerCreate.onPropertyTypeChange()'
                        class='property-spec-select select-no-arrow text-center'>
                  <option value='' disabled>Type</option>
                  <option *ngFor='let item of buyerCreate.propertyType | keyvalue:buyerCreate.keepOrder'
                          value='{{item.key}}'>{{ item.value }}</option>
                </select>
              </div>
              <div class='col-2'>
                <select formControlName='bed' class='property-spec-select select-no-arrow text-center'>
                  <option value='' disabled>Bed</option>
                  <option *ngFor='let item of buyerCreate.bedValues' [value]='item'>{{ item }}</option>
                </select>
              </div>
              <div class='col-2'>
                <select formControlName='bath' class='property-spec-select select-no-arrow text-center'>
                  <option value='' disabled>Bath</option>
                  <option *ngFor='let item of buyerCreate.bedValues' [value]='item'>{{ item }}</option>
                </select>
              </div>
              <div class='col-2'>
                <select formControlName='car' class='property-spec-select select-no-arrow text-center'>
                  <option value='' disabled>Car</option>
                  <option *ngFor='let item of buyerCreate.bedValues' [value]='item'>{{ item }}</option>
                </select>
              </div>
              <div class='col-4'>
                <input nbInput fieldSize='tiny' fullWidth formControlName='land' class='property-spec-input text-center' placeholder='Land'>
              </div>
              <hr class='m-2 w-100'>
              <div class='col-12'>
                <div class='col-12 p-0'>Min Budget</div>
                <div class='col-12 p-0 mt-1'>
                  <select size='tiny' formControlName='minBuyPrice' class='width100 property-budget-select'
                          (change)='buyerCreate.onMinPriceChange(buyerForm.controls?.minBuyPrice?.value)'>
                    <option value='0'>$min</option>
                    <option *ngFor='let price of buyerCreate.BUYER_PRICE()' [value]='price.key'>{{ price.value }}</option>
                  </select>
                </div>
              </div>
              <div class='col-12 mt-2'>
                <div class='col-12 p-0'>Max Budget</div>
                <div class='col-12 p-0 mt-1'>
                  <select size='tiny' formControlName='maxBuyPrice' class='width100 property-budget-select'
                          (change)='buyerCreate.onMaxPriceChange(buyerForm.controls?.maxBuyPrice?.value)'>
                    <option value='0'>$max</option>
                    <option *ngFor='let price of buyerCreate.BUYER_PRICE()' [value]='price.key'>{{ price.value }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "A")'>
            <div class='row custom-area m-1 mt-2 p-2'>
              <div class='col-12 text-center buyer-section-title'>
                <span *ngIf="buyerForm.controls.isActive.value !== 'INACTIVE'">AREA ENQUIRYING</span>
                <span *ngIf="buyerForm.controls.isActive.value === 'INACTIVE'">AREA BOUGHT IN</span>
              </div>
              <div class='col-2 mt-2'>
                <nb-form-field class='w-100'>
                  <input nbInput fullWidth placeholder='Postcode' fieldSize='tiny' class='buyer-address-control'
                         [(ngModel)]='buyerCreate.postcode'
                         [typeahead]='buyerCreate.filterPostcode$'
                         [ngModelOptions]='{standalone: true}'
                         [typeaheadAsync]='true'
                         (typeaheadOnSelect)='buyerCreate.selectPostcode($event)'
                         typeaheadOptionField='code'
                         typeaheadMinLength='3'
                         typeaheadWaitMs='1000'
                         [value]="buyerCreate.postcode ? buyerCreate.postcode : null">
                </nb-form-field>
              </div>
              <div class='col-5 mt-2'>
                <select size='tiny' formControlName='districtId' class='width100 buyer-address-control buyer-address-select'
                        (change)='buyerCreate.onSuburbSelectChange(buyerForm.controls?.districtId?.value)'>
                  <option [ngValue]='null'>All Suburbs</option>
                  <option *ngFor='let key of buyerCreate.filteredDistricts' [value]='key.districtId'>{{ key.name }}</option>
                </select>
              </div>
              <div class='col-5 mt-2'>
                <select fullWidth formControlName='streetId' class='width100 buyer-address-control buyer-address-select'>
                  <option [ngValue]='null'>All Streets</option>
                  <option *ngFor='let key of buyerCreate.filteredStreets' [value]='key.streetId'>{{ key.name }}</option>
                </select>
              </div>
              <div class='col-3 mt-2'>
                <input type='number' nbInput fieldSize='tiny' formControlName='numberFrom' fullWidth class='buyer-address-control' placeholder='From'>
              </div>
              <div class='col-3 mt-2'>
                <input type='text' nbInput fieldSize='tiny' formControlName='numberTo' fullWidth class='buyer-address-control' placeholder='To'>
              </div>
              <div class='col-12 mt-2'>
                <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='enq' class='buyer-address-control' placeholder='Enq'>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2 p-2'
                 *ngIf="buyerForm.controls?.buyerCode?.value === 'B' || buyerForm.controls?.buyerCode?.value === 'T'">
              <div class='col-12 text-center buyer-section-title'>PREFERRED AREA</div>
              <div class='col-12 mt-2'>
                <input nbInput fullWidth fieldSize='tiny' class='buyer-address-control'
                       placeholder='Select postcode'
                       inputmode='numeric' maxlength='4'
                       [(ngModel)]='buyerCreate.preferredPostcodeInput'
                       [ngModelOptions]='{standalone: true}'
                       [typeahead]='buyerCreate.filterPreferredPostcode$'
                       [typeaheadAsync]='true'
                       (typeaheadOnSelect)='buyerCreate.selectPreferredPostcode($event)'
                       typeaheadOptionField='code'
                       typeaheadMinLength='2'
                       typeaheadWaitMs='300'>
              </div>
              <div class='col-12 buyer-preferred-list' *ngIf='buyerCreate.preferredAreas.length'>
                <span class='buyer-preferred-chip' *ngFor='let postcode of buyerCreate.preferredAreas'>
                  {{ postcode }}
                  <button type='button' aria-label='Remove postcode'
                          (click)='buyerCreate.removePreferredPostcode(postcode)'>&times;</button>
                </span>
              </div>
            </div>
            <div class='row custom-area m-1 mt-2 p-2' *ngIf="buyerForm.controls?.buyerCode?.value === 'B'">
              <div class='col-12 text-center buyer-section-title'>LIVING AREA</div>
              <div class='col-2 mt-2'>
                <nb-form-field class='w-100'>
                  <input nbInput fullWidth placeholder='Postcode' fieldSize='tiny' class='buyer-address-control'
                         [(ngModel)]='buyerCreate.livingPostcode'
                         [typeahead]='buyerCreate.filterLivingPostcode$'
                         [ngModelOptions]='{standalone: true}'
                         [typeaheadAsync]='true'
                         (typeaheadOnSelect)='buyerCreate.selectLivingPostcode($event)'
                         typeaheadOptionField='code'
                         typeaheadMinLength='3'
                         typeaheadWaitMs='1000'>
                </nb-form-field>
              </div>
              <div class='col-5 mt-2'>
                <select formControlName='livingDistrictId'
                        class='width100 buyer-address-control buyer-address-select'
                        (change)='buyerCreate.onLivingSuburbSelectChange(buyerForm.controls?.livingDistrictId?.value)'>
                  <option [ngValue]='null'>Suburb</option>
                  <option *ngFor='let district of buyerCreate.livingFilteredDistricts'
                          [value]='district.districtId'>{{ district.name }}</option>
                </select>
              </div>
              <div class='col-5 mt-2'>
                <select formControlName='livingStreetId'
                        class='width100 buyer-address-control buyer-address-select'>
                  <option [ngValue]='null'>Street</option>
                  <option *ngFor='let street of buyerCreate.livingFilteredStreets'
                          [value]='street.streetId'>{{ street.name }}</option>
                </select>
              </div>
              <div class='col-3 mt-2'>
                <input nbInput fullWidth fieldSize='tiny' formControlName='livingUnit'
                       class='buyer-address-control' placeholder='Unit'>
              </div>
              <div class='col-3 mt-2'>
                <input nbInput fullWidth fieldSize='tiny' formControlName='livingNumberFrom'
                       class='buyer-address-control' placeholder='House Number'>
              </div>
              <div class='col-12 mt-2'>
                <button type='button' nbButton size='small' status='primary'
                        (click)='buyerCreate.lookupLivingAddress()'
                        [hidden]='!buyerCreate.data || !buyerCreate.data.buyerId'>Look up</button>
              </div>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "N")'>
            <div class='row custom-area m-1 mt-2 p-2'>
              <div class='col-6 text-center'>
                {{ isBlank ? '' : 'First Enq Date : ' + (buyerForm.controls?.enqDate2?.value | date:'dd/MM/yyyy') }}
              </div>
              <div class='col-6 text-center'>
                {{ isBlank ? '' : 'Week Count : ' + buyerCreate.weekCount }}
              </div>
              <div class='col-12 mt-2'>
                <nb-form-field>
                  <input [nbDatepicker]='datepickerEnqDate2' nbInput fieldSize='tiny'
                         fullWidth formControlName='enqDate2' placeholder='Enq date'/>
                  <nb-datepicker #datepickerEnqDate2></nb-datepicker>
                </nb-form-field>
              </div>
              <div class='col-6 mt-2'>
                <nb-form-field>
                  <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='noWeek' placeholder='NW'>
                </nb-form-field>
              </div>
              <div class='col-6 mt-2'>
                <nb-form-field>
                  <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='noHouse' placeholder='NH'>
                </nb-form-field>
              </div>
              <ng-container *ngIf='buyerForm.controls.tenant.value'>
                <div class='col-6 mt-2'>
                  <nb-form-field>
                    <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='yearIn' placeholder='year in'>
                  </nb-form-field>
                </div>
                <div class='col-6 mt-2'>
                  <nb-form-field>
                    <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='monthIn' placeholder='month in'>
                  </nb-form-field>
                </div>
                <div class='col-6 mt-2'>
                  <nb-form-field>
                    <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='weekOut' placeholder='week out'>
                  </nb-form-field>
                </div>
                <div class='col-6 mt-2'>
                  <nb-form-field>
                    <input type='text' nbInput fieldSize='tiny' fullWidth formControlName='dayOut' placeholder='day out'>
                  </nb-form-field>
                </div>
              </ng-container>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='isCreateMode || (isSectionView && activeSection === "I")'>
            <div class='row custom-area m-1 mt-2 p-2' *ngIf='buyerForm.controls.buyer.value'>
              <div class='col-8'>
                <span class='appointment-header'>Buyer Appointment</span>
              </div>
              <div class='col-2 text-center'>
                <span class='status-active checked-button ml-1'>
                  <nb-icon [icon]="'plus-outline'" (click)='createTask()' pack='eva'></nb-icon>
                </span>
              </div>
              <div class='col-2 text-center'>
                <span class='status-active checked-button ml-1'>
                  <nb-icon [icon]="'plus-outline'" (click)='createTaskForCurrentAddress()' pack='eva'></nb-icon>
                </span>
              </div>
              <div class='col-12' *ngFor='let buyerTask of buyerCreate.buyerTasks'>
                <div class='row w-100 mt-2'>
                  <div class='col-9 appointment-without-border task-address pl-3'
                       [nbTooltip]='appointmentAddress(buyerTask)'>
                    {{ appointmentAddress(buyerTask) }}
                  </div>
                  <div class='col-3 appointment-without-border task-address'
                       nbTooltip="{{ buyerTask.task?.toDate | date:'dd/MM/yyyy hh:mm' }}">
                    {{ buyerTask.task?.toDate | date:'dd/MM/yyyy hh:mm' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class='col-12 mt-2' *ngIf='buyerCreate?.showHistory'>
            <nb-card class='log-view mt-2 custom-area'>
              <nb-list>
                <nb-list-item *ngFor='let log of buyerCreate.sortHistoryList()'>
                  <div [innerHTML]='buyerCreate.formatLog(log)'></div>
                </nb-list-item>
              </nb-list>
            </nb-card>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer class='mb-2 p-0 mt-2 border-top-0 buyer-create-v2-footer'>
        <div class='col-12 d-inline-flex justify-content-center mt-2'>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    (click)='new()'>
              <nb-icon icon='plus-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>New</div>
            </button>
          </div>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    (click)='buyerCreate.selectAddress()'>
              <nb-icon icon='pin-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>Enq</div>
            </button>
          </div>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    [nbPopover]='tag'>
              <nb-icon icon='pricetags-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>Tag</div>
            </button>
          </div>
          <div class='override-width p-1 text-center'>
            <button type='button' nbButton fullWidth size='medium'
                    class='custom-button-footer d-block p-0 text-center button-details'
                    (click)='save()'
                    [disabled]='buyerCreate?.isUpdating === true'>
              <nb-icon icon='save-outline' pack='eva' class='m-0'></nb-icon>
              <div class='text-center mt-2'>{{ isBulkUpdateMode ? 'Save All' : 'Save' }}</div>
            </button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </form>
</div>

<ng-template #tag>
  <div class='row m-0 p-2 buyer-tag-popover' *ngIf='buyerCreate'>
    <div class='col-12'>
      <input
        [(ngModel)]='buyerCreate.categoryName'
        [ngModelOptions]='{standalone: true}'
        [typeahead]='buyerCreate.filterCategory$'
        [typeaheadAsync]='true'
        (typeaheadOnSelect)='buyerCreate.selectCategory($event)'
        typeaheadOptionField='name'
        typeaheadWaitMs='1000'
        placeholder='Search Tag'
        nbInput fieldSize='tiny' fullWidth>
    </div>
    <div class='col-12 mt-2'>
      <div *ngFor='let category of buyerCreate.selectedCategories' class='category-block buyer-tag-item mt-2'>
        {{ category.name }}
        <button type='button' class='btn btn-danger btn-sm'
                (mousedown)='$event.stopPropagation()'
                (click)='$event.preventDefault(); $event.stopPropagation(); buyerCreate.removeCategory(category)'>
          <i class='fa fa-times' aria-hidden='true'></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>
